import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ExpertProfile from "@/pages/ExpertProfile";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/experts/$id")({
  head: ({ params }) => seoHead(`/experts/${params.id}`),
  component: () => (
    <AuthGate><ExpertProfile /></AuthGate>
  ),
});
